import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=02113634&"
import script from "./Polls.vue?vue&type=script&lang=js&"
export * from "./Polls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports